import { useFetchAllQueries } from 'shared/base/hooks/useFetchAllQueries';

import { mapPieChartData } from '../../mappers';
import { ReportCardWrapper } from '../cardWrapper';
import { PieChart } from './pieChart';
import { PieChartLoader } from './pieChartLoader';
import { ReportCardVariantProps, PieChartVariant } from '../../types';

interface AdditionalProps {
  variantProps: PieChartVariant;
}

export const PieChartReportCard = ({
  columnFormatter,
  description,
  query,
  sx,
  title,
  variantProps,
}: ReportCardVariantProps & AdditionalProps) => {
  const queryResult = useFetchAllQueries(query);

  return (
    <ReportCardWrapper
      description={description}
      query={query.baseQuery}
      queryResult={queryResult}
      renderContent={(successfulResult) => {
        const mappedData = mapPieChartData(successfulResult.data, columnFormatter);

        return <PieChart data={mappedData} {...variantProps} />;
      }}
      renderLoading={() => <PieChartLoader />}
      sx={sx}
      title={title}
    />
  );
};
